import axios from "axios";
import { environment } from "../../environments/environment";
import { AUTH_CONSTANTS } from "../utils/auth-constants";


export interface Company {
    fantasy_name: string,
    cnpj: string,
    company_email: string,
    phone: string,
    postcode: string,
    address: string,
    address_number: string,
    city_id: string,
    website: string,
    description: string,
    motivation: string,
    full_name: string,
    password: string,
    cpf: string,
    gender: string,
    date_of_birth: string,
    manager_email: string
}

export interface CreateCompany {
    fantasy_name: string,
    cnpj: string,
    company_email: string,
    phone: string,
    postcode: string,
    address: string,
    address_number: string,
    address_district?: string,
    city_id: string | number,
    segment_id: string | number,
    website: string,
    description: string,
    motivation: string,
    full_name: string,
    password: string,
    cpf: string,
    gender: string,
    date_of_birth: string,
    manager_email: string,
    em_unit?: number,
    ie?: string
}

export interface CompanyLookupResult {
    exists: boolean
    company?: {
        id: string
        name: string
        cnpj: string
    }
}

export interface CreateCompanyManager {
    cnpj: string
    full_name: string
    manager_email: string
    password: string
    cpf: string
    date_of_birth?: string
    gender?: string
}

export const createCompany = async (data: CreateCompany): Promise<any> => {
    const response = await axios.post<any>(environment.apiUrl+'/api/company_new/register/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};

export const lookupCompanyByCNPJ = async (cnpj: string): Promise<CompanyLookupResult> => {
    const response = await axios.get<CompanyLookupResult>(
        `${environment.apiUrl}/api/company-lookup/`,
        {
            params: { cnpj },
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const createCompanyManager = async (data: CreateCompanyManager): Promise<any> => {
    const response = await axios.post<any>(environment.apiUrl+'/api/company_managers/register/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};

export const listCompanies = async (params?: any): Promise<{
    totalCount: number,
    data: any[]
}> => {
    const filters: string[] = [];

    if (params?.search) {
        // Escapar aspas duplas para não quebrar a query GraphQL
        const safeSearch = String(params.search).replace(/"/g, '\\"');
        filters.push(`search: "${safeSearch}"`);
    };

    if (params?.id) {
        filters.push(`id: ${params.id}`);
    };

    const args = filters.length ? `(${filters.join(', ')})` : '';

    const response = await axios.post(`${environment.apiUrl}/graphql`,
        {
          "operationName": "AllJobs",
          "query": `query AllJobs {
                        allCompanies${args} {
                            edges {
                                node {
                                    companyId
                                    name
                                }
                            },
                            totalCount
                        }
                    }`,
          "variables": {}
        }, {
          headers: {
            "content-type": "application/json"
          }
        }
    );

    if(response.status !== 200) {
        throw Error('error');
    };

    return {
        data: response.data.data.allCompanies.edges.map((x: any) => x.node),
        totalCount: response.data.data.allCompanies.totalCount
    };
};

export const retrieveCompany = async () => {
    const response = await axios.get<Company>(environment.apiUrl+'/api/candidate/'+localStorage.getItem('candidate_id'), {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const retrieveCompanyManager = async (managerId?: string | null) => {
    const resolvedManagerId =
        managerId ?? localStorage.getItem(AUTH_CONSTANTS.STORAGE_KEYS.MANAGER_ID);

    if (!resolvedManagerId) {
        throw new Error('manager_id_not_found');
    }

    const response = await axios.get<any>(
        `${environment.apiUrl}/api/managers/${encodeURIComponent(resolvedManagerId)}/`,
        {
            headers: {
                'Content-Type': 'application/json'
            },
            timeout: 15000
        }
    );

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};